import { jsx as _jsx } from "preact/jsx-runtime";
import { useCallback, useEffect, useMemo, useState, } from 'preact/compat';
import useGlobalEvent from 'beautiful-react-hooks/useGlobalEvent';
import defaultValues from '@bookingForm/validation/defaultValues';
import { singleActivitySchema } from '@widgets/GenericBookings/validation/schema';
import BookingFormWrapper from '@genericBookings/components/BookingFormWrapper';
import StaticFormSteps from '@genericBookings/types/StaticFormSteps';
import Form from '@bookingForm/components/Form/Form';
import { CourseProvider } from '@bookingForm/context/Course';
import store from '@genericBookings/store';
import { clearActivities, resetFetchedAll } from '@genericBookings/store/reducers/activities';
import { OptionsCTX, optionsDefaults } from './context/Options';
import convertDataAttributes from './convertDataAttributes';
function BookingForm(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const isSwwModal = dataset?.theme === 'sww';
    const [refresh, setRefresh] = useState(false);
    const onBookNowClosed = useGlobalEvent('booknow.closed');
    const formOptions = useMemo(() => ({
        ...optionsDefaults,
        ...formattedAttributes,
        isMulti: false,
        isBuilder: false,
        debug: false,
    }), [formattedAttributes]);
    const { productId, hideQuickPayButtons } = formOptions;
    const schema = singleActivitySchema;
    const getDefaultAcceptTerms = useCallback(() => {
        if (formOptions.requiresSignature)
            return false;
        return hideQuickPayButtons ? true : defaultValues.acceptTerms;
    }, [formOptions.requiresSignature, hideQuickPayButtons]);
    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                setRefresh(false);
            }, 1);
        }
    }, [refresh]);
    onBookNowClosed(() => {
        if (!isSwwModal)
            return;
        // the store is a module singleton, so it survives the remount below
        store.dispatch(clearActivities());
        store.dispatch(resetFetchedAll());
        setRefresh(true);
    });
    if (refresh) {
        return null;
    }
    return (_jsx(BookingFormWrapper, { schema: schema, defaultValues: {
            ...defaultValues,
            ProductId: productId ?? 217,
            acceptTerms: getDefaultAcceptTerms(),
            SignatureDate: new Date().toISOString(),
            SignatureName: '',
        }, steps: StaticFormSteps, theme: (formattedAttributes.theme ?? {}), OptionsCTX: OptionsCTX, options: formOptions, children: _jsx(CourseProvider, { children: _jsx(Form, {}) }) }));
}
export default BookingForm;
